module.exports = __webpack_public_path__ + "img/fine_dashboard.f597385c.png";